import React from "react";
import { useParams } from "react-router-dom";

import PageContainer from "components/lib/PageContainer";
import UserContainer from "containers/User";
import { StoreIdParam } from "config/raven";
import { NewContactForm } from "components/Contact/FormNew/NewContactForm";
import { StoreBreadcrumbBuilder } from "utils/breadcrumb";

export const ContactFormNew: React.FC = () => {
  const userContainer = UserContainer.useContainer();
  const { isAgency } = userContainer;

  const { storeId } = useParams<StoreIdParam>();

  return (
    <PageContainer
      header="問い合わせフォーム新規作成"
      breadcrumbs={new StoreBreadcrumbBuilder(isAgency, storeId)
        .contactsFormPage()
        .build("問い合わせフォーム新規作成")}
    >
      <NewContactForm isAgency={isAgency} storeId={storeId} />
    </PageContainer>
  );
};
